import _ from 'lodash';

import { UpdateTypes } from '@/common/service/checkout-utils';
import {
  planTypes,
  BASE_PLAN_SUB_TYPES,
  AUDIO_SUB_TYPES,
} from '@/common/constants';
import { computedPbxBasePlans } from '@/common/service/computers/plans/pbx';
import {
  isOnlineNotSupportPlan,
  ONLINE_NOT_SUPPORT_BILLING_CYCLE,
} from '@/common/service/non-standard-billing-cycle-utils';

import { getMeetingPlanByCategory } from '@/plans/ZOOM_MEETING/common/utils';

export const getMeeting2BizPlusUpdateForm = (getters) => {
  const actionType = UpdateTypes.MEETING_TO_BIZ_PLUS;

  const boughtMeetingCategory = _.chain(getters.boughtPlans)
    .find((p) => p.type === planTypes.ZOOM_MEETING)
    .get('category')
    .value();

  const bizPlan = getMeetingPlanByCategory(getters.boughtPlans, boughtMeetingCategory);
  // if has zp base plan, filter zp base plan
  const pbxBasePlans = computedPbxBasePlans(getters.boughtPlans);
  // no op free trail plan
  const planList = getters.getSelectedPlans.filter(p => {
      if (pbxBasePlans.length && p.type === planTypes.ZOOM_PHONE) {
          return false;
      }
      return true;
  }).map(p => {
    const extraKeys = {}
    if (
      p.type !== planTypes.ZOOM_PHONE &&
      (ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(p.billing_cycle) ||
      ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(bizPlan.billing_cycle))
    ) {
      Object.assign(extraKeys, { planType: p.plan_type, oldPlanType: bizPlan.plan_type })
    }
    return {
      oldPlanCode: p.type === planTypes.ZOOM_PHONE ? '' : bizPlan.plan_code,
      quantity: p.cartInfo.selected_number,
      planCode: p.plan_code,
      ...extraKeys
    }
  });
  return { planList, actionType };
};

export function getPro2ProPlusUpdateForm(getters) {
  const actionType = UpdateTypes.PRO_TO_PTO_PLUS;
  const pro = getMeetingPlanByCategory(getters.boughtPlans, BASE_PLAN_SUB_TYPES.PRO);
  let planList = getters.getSelectedPlans.map(p => {
    let oldPlanCode = '';
    if (p.type === planTypes.ZONE_PRO_PLUS) {
      oldPlanCode = pro.plan_code;
    }
    const extraKeys = {}
    if (
      p.type !== planTypes.ZOOM_PHONE &&
      (ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(p.billing_cycle) ||
        ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(pro.billing_cycle))
    ) {
      Object.assign(extraKeys, { planType: p.plan_type, oldPlanType: pro.plan_type })
    }
    return {
      oldPlanCode,
      planCode: p.plan_code,
      quantity: p.cartInfo.selected_number,
      ...extraKeys
    }
  }).filter(p => {
    const isBought = getters.boughtPlans.find(_p => _p.plan_code === p.planCode);
    if (isBought) {
      return false;
    }
    return p;
  });
  return {
    actionType,
    planList,
  }
}

export function getProPlus2BizPlusUpdateForm(getters) {
  const bizplus = getters.getSelectedPlans.find(p => p.type === planTypes.ZOOM_ONE_BUNDLE);
  const prop = getters.boughtPlans.find(p => p.type === planTypes.ZONE_PRO_PLUS);
  const extraKeys = {}
  if (
    ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(prop.billing_cycle) ||
      ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(bizplus.billing_cycle)
  ) {
    Object.assign(extraKeys, { planType: bizplus.plan_type, oldPlanType: prop.plan_type })
  }
  return {
    actionType: UpdateTypes.PRO_PLUS_TO_PRO_PLUS,
    planList: [
      {
        oldPlanCode: prop.plan_code,
        planCode: bizplus.plan_code,
        quantity: bizplus.cartInfo.selected_number,
        ...extraKeys
      }
    ]
  }
}

export const checkAudioChange = (getters, form) => {
  const selectedAudioPlan = getters.getSelectedPlans.find(item => (
      item.type === planTypes.TOLLFREE &&
      item.category === AUDIO_SUB_TYPES.UNLIMITED
  ));
  if(selectedAudioPlan && form.planList.every((p) => p.planCode !== selectedAudioPlan.plan_code)) {
    const extraKeys = {}
    if (isOnlineNotSupportPlan({ planType: selectedAudioPlan.type, billingCycle: selectedAudioPlan.billing_cycle, category: selectedAudioPlan.category })) {
      Object.assign(extraKeys, { planType: selectedAudioPlan.plan_type, oldPlanType: selectedAudioPlan.plan_type })
    }
    form.planList.push({
      quantity: selectedAudioPlan.cartInfo.selected_number,
      planCode: selectedAudioPlan.plan_code,
      oldPlanCode: selectedAudioPlan.plan_code,
      ...extraKeys
    });
  }
  return form;
}
